















































































import Vue from 'vue';
import truncateStringMiddle from '../helpers/truncateStringMiddle';
import SelectWithCustom from './SelectWithCustom.vue';

export default Vue.extend({
	props: [
		'filter',
		'filters',
		'index',
		'field',
		'properties',
		'flattenedProperties',
		'propertyValues',
		'ungroupedProperties',
		'groupedProperties',
		'objectTypeInstance',
		'getPropertyValues',
	],
	components: {
		'gppa-select-with-custom': SelectWithCustom,
	},
	created: function () {
		if (this.filter.property) {
			return this.getPropertyValues(this.filter.property);
		}

		this.filter.property = Object.values(this.flattenedProperties)[0].value;
	},
	data: function () {
		return {
			i18nStrings: window.GPPA_ADMIN.strings,
			defaultOperator: 'is',
		}
	},
	watch: {
		'filter.property': function (val, oldVal) {
			this.getPropertyValues(val);
		}
	},
	methods: {
		truncateStringMiddle: truncateStringMiddle,
		/**
		 * resetFilter's contents were originally extracted from the 'filter.property' watcher to prevent the
		 * filter value from needlessly resetting to having no value when the field itself changes.
		 */
		resetFilter: function() {
			this.filter.value = '';
			this.filter.operator = this.defaultOperator;
		}
	},
	computed: {
		specialValues: function () {

			return [
				{
					label: 'Current User ID',
					value: 'special_value:current_user:ID',
				},
				{
					label: 'Current Post ID',
					value: 'special_value:current_post:ID',
				}
			]

		},
		formFieldValues: function () {

			var formFieldValues = [];

			const excludedFormFieldValueInputTypes = ['chainedselect'];

			for (var i = 0; i < form.fields.length; i++) {

				const field = form.fields[i];
				const inputType = GetInputType(field);

				if (excludedFormFieldValueInputTypes.includes(inputType)) {
					continue;
				}

				if (IsConditionalLogicField(field) || ['date'].includes(inputType)) {

					if (field.inputs && !['checkbox', 'email'].includes(inputType)) {
						for (var j = 0; j < field.inputs.length; j++) {
							var input = field.inputs[j];
							if (!input.isHidden) {
								formFieldValues.push({
									label: GetLabel(field, input.id),
									value: 'gf_field:' + input.id,
								});
							}
						}
					} else {
						formFieldValues.push({
							label: GetLabel(field),
							value: 'gf_field:' + field.id,
						});
					}

				}

			}

			return formFieldValues;

		},
		operators: function () {

			/* Labels for operators are pulled from i18nStrings in the Vue bindings */
			if (this.filter.property in this.flattenedProperties) {
				var property = this.flattenedProperties[this.filter.property];

				if ('operators' in property) {
					return property.operators;
				}

				if ('group' in property) {
					var group = this.objectTypeInstance.groups[property.group];

					if ('operators' in group) {
						return group.operators;
					}
				}
			}

			return window.GPPA_ADMIN.defaultOperators;

		}
	},
});
